const abilityGroups = state => state.abilityGroups
const account = state => state.account
const loggedIn = state => state.loggedIn
const loginError = state => state.loginError
const notifications = state => state.notifications
const numbers = state => state.numbers
const roles = state => state.roles
const user = state => state.user


export default {
  abilityGroups,
  account,
  loggedIn,
  loginError,
  notifications,
  numbers,
  roles,
  user
}
